import { useQuery } from '@tanstack/react-query'
import { deleteRecipe } from '@/data/recipes/deleteRecipe'
import { getRecipes } from '@/data/recipes/getRecipes'
import { queryKeys } from '@/lib/queryKeys'
import { GovUKResourceListPage } from '@/components/govuk'

export function RecipesListPage() {
  const { data: recipes = [], isLoading } = useQuery({
    queryKey: queryKeys.recipes.lists(),
    queryFn: () => getRecipes(),
  })

  return (
    <GovUKResourceListPage
      title="Recipes"
      caption="Shopping lists for Aldi"
      addRoute="/recipes/addRecipe"
      addButtonText="Add recipe"
      detailRoute={(id) => `/recipes/${id}`}
      items={recipes}
      isLoading={isLoading}
      queryKey={queryKeys.recipes.lists()}
      deleteFn={(input) => deleteRecipe({ data: { recipeId: input.data.id } })}
      renderItem={(recipe) => ({
        title: recipe.name,
        subtitle: 'Tap to view ingredients',
      })}
    />
  )
}
